import { AfterViewInit, ChangeDetectorRef, Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { startWith, switchMap, takeUntil } from 'rxjs/operators';
import { DevicePilomat } from '../model/devicePilomat';
import { DeviceService } from '../service/device.service';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';
import { Subscription, interval, Subject } from 'rxjs';
import { SerialsList } from '../model/serialsList';
import { DeviceState } from '../model/deviceState';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css']
})
export class DevicesComponent implements OnInit, AfterViewInit {

  @ViewChild('devicesloader', { static: true }) loader;

  // private destroy$ = new Subject<void>();


  backgroundImage: string = "";

  deviceList: DevicePilomat[];
  serials: SerialsList;

  filterString: string = "";

  timeInterval: Subscription;
  deviceStateSubscription: Subscription;

  mapString: string = $localize`:@@devices_map:Mappa`;
  listString: string = $localize`:@@devices_list:Lista`;
  activatedDevicesString: string = $localize`:@@devices_activated_devices:Dispositivi attivati`;

  showBackGroundImage: string[] = ["questura@pilomat.com", "questura1@pilomat.com", "gestore@1control.it", "gestore@pilomat.com"];
  isAdmin: boolean = false;

  constructor(
    private deviceService: DeviceService,
    private userService: UserService,
    private router: Router,
    private cdRef: ChangeDetectorRef) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loader.showLoading();
    });

    this.getUserEmail();
    this.getDeviceList();
  }

  ngOnChanges(changes: SimpleChanges) {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }
  }

  ngOnDestroy(): void {


    // this.destroy$.next();
    // this.destroy$.complete();
    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }

    if (this.deviceStateSubscription) {
      this.deviceStateSubscription.unsubscribe();
    }
  }

  onDeviceSelected(device: DevicePilomat): void {

    Log.debug("onDeviceSelected: " + JSON.stringify(device));

    this.router.navigate(['device/' + device.serial]);
  }

  onKey(event: any) {

    this.filterString = event.target.value;
  }


  getDeviceList() {

    this.loader.showLoading();

    this.deviceService.getDevices().subscribe(devices => {

      Log.debug("Devices component ts device list");
      Log.debug(devices);

      this.deviceList = devices;

      this.cdRef.detectChanges();

      setTimeout(() => {
        this.startUpdatingDevicesStates();
      }, 500);


    }, error => {

      this.loader.hideLoading();
      this.loader.showError();

      this.cdRef.detectChanges();
    });
  }


  startUpdatingDevicesStates() {

    this.serials = new SerialsList();

    for (let i = 0; i < this.deviceList.length; i++) {
      this.serials.devices.push(this.deviceList[i].serial);
    }

    setTimeout(() => {
      this.loader.hideLoading();
    }, 1250);

    //faccio un prime updateState per avere i dati all'avvio della pagina
    this.updateState();

    //timeInterval lo ripeterà ogni 15 secondi (parte 6 secondi dopo il caricamento della pagina)
    this.timeInterval = interval(15000).subscribe((res) => {
      this.updateState();
    });
  }

  updateState() {
    this.deviceStateSubscription = this.deviceService.getDevicesState(this.serials).subscribe((response) => {

      for (let i = 0; i < response.length; i++) {
        // TODO
        // Potrebbero non arrivare completi o in ordine
        // array.find(device.serial == response[i].serial){
        //   etc
          
        this.deviceList[i].updateState(response[i]);
        this.cdRef.detectChanges();
      }

    });
  }

  // startUpdatingDevicesStates() {
  //   this.serials = new SerialsList();
  //   for (let device of this.deviceList) {
  //     this.serials.devices.push(device.serial);
  //   }
  
  //   setTimeout(() => {
  //     this.loader.hideLoading();
  //   }, 1250);
  
  //   // Fire immediately and then every 15s, but auto-unsubscribe on destroy
  //   interval(15000).pipe(
  //     startWith(0),
  //     takeUntil(this.destroy$),
  //     switchMap(() => this.deviceService.getDevicesState(this.serials))
  //   ).subscribe((response) => {
  //     for (let i = 0; i < response.length; i++) {
  //       const state = response[i];
  //       const device = this.deviceList.find(d => d.serial === state.serial);
  //       if (device) {
  //         device.updateState(state);
  //       }
  //     }
  //     this.cdRef.detectChanges();
  //   });
  // }

  addDevice() {
    this.router.navigate(['add-device']);
  }

  getUserEmail() {
    this.userService.getFirebaseUserObs().subscribe(firebaseUser => {
      this.userService.getMe().subscribe(user => {
        if (this.showBackGroundImage.includes(user.email)) {
          this.backgroundImage = "url('assets/img/Banner_pconnect_Milano_day2.jpg')";
        } else {
          this.backgroundImage = "unset"
        }
        if (user.email == "admin@pilomat.it") {
          this.isAdmin = true;
        }
      }, errorRes => {
        Log.debug("error cannot retrieve user ");
      });
    }, errorRes => {
      Log.debug("error cannot retrieve user ");
    });
  }
}

